module.exports = __webpack_public_path__ + "media/images/DoorRight-5d7e3c780250b9d7b68d60568dd0e8a0.png";